
import { defineComponent, PropType, ref } from "vue";
import {
  calcLineAmount,
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";
import { IVatTuHopDongResponseBase } from "@/core/interfaces/ApiResponses";
import useVatTu from "@/core/hooks/use-vat-tu";
import VatTuDetailModal from "@/components/vat-tu/VatTuDetailModal.vue";
import Setting from "@/components/shared/setting/Setting.vue";
import type { SettingAction } from "@/components/shared/setting/Setting.vue";
import IconEye from "@/icons/IconEye.vue";
import {
  VAT_TU_TABLE_COLUMN_WIDTHS,
  VatTuTable,
} from "@/components/shared/vat-tu-table";

export default defineComponent({
  name: "hop-dong-vat-tu-table",

  components: { Setting, VatTuDetailModal, VatTuTable },

  emits: ["refresh"],

  props: {
    curPage: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array as PropType<Array<IVatTuHopDongResponseBase>>,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { isTextDangerColumn } = useVatTu();

    const selectedVatTuId = ref<number | undefined>(undefined);

    const normalizeCheckboxValue = (value: unknown) =>
      value === true || value === 1 || value === "1";

    const toVatTuItems = (items: IVatTuHopDongResponseBase[] = []) =>
      items.map((item) => ({
        ...item,
        thu_hoi: normalizeCheckboxValue(item.thu_hoi),
        cong_ty_duyet: normalizeCheckboxValue(item.cong_ty_duyet),
      }));

    const vatTuItems = ref(toVatTuItems(props.items));

    return {
      columnWidths: VAT_TU_TABLE_COLUMN_WIDTHS,
      isTextDangerColumn,
      selectedVatTuId,
      vatTuItems,
      toVatTuItems,
    };
  },

  watch: {
    items(value: IVatTuHopDongResponseBase[]) {
      this.vatTuItems = this.toVatTuItems(value);
    },
  },

  methods: {
    calcLineAmount,
    formatAmount,
    formatQuantity,
    formatUnitPrice,

    getSettingActions(row: IVatTuHopDongResponseBase): SettingAction[] {
      return [
        {
          icon: IconEye,
          label: "Chi tiết",
          tooltip: "Thông tin chi tiết v/tư",
          onClick: () => {
            this.selectedVatTuId = row.id;
          },
        },
      ];
    },
  },
});
